module.exports = __webpack_public_path__ + "static/img/glt1350-fcm-325bb.aaf3f61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/glt1350-fcm-325bb.jpg
// module id = hJST
// module chunks = 0